import React from 'react';
import {Link} from 'react-router';
import * as PathConstants from '../../constants/pathConstants';

class PageForbidden extends React.Component {
  render() {
    return (
      <div>
        <h1 style={{
          marginBottom: '20px'
        }}>
          Access Denied
        </h1>
        You are not authorized to access this page.
        <div style={{
          minHeight: '200px'
        }}>
          <Link to={PathConstants.pathToEstablishmentsDashboardPage}>Return</Link> to 
          previous page.</div>
      </div>
    );
  }
}

export default PageForbidden;



/** WEBPACK FOOTER **
 ** ./src/components/common/PageForbidden.js
 **/